import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kts-services',
  template: '<router-outlet></router-outlet>',
  styles: ['']
})
export class ServicesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/Yi-Yu/Documents/Actual Documents/Katiso/katiso/src/app/components/services/services.component.ts